var mp = mp || {};


// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
    var $toggleButton = $('.header__hamburger');
    var $drawerWraper = $('.header__navigation');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('touchstart click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
        $('.header').toggleClass('is_open');
        $('body').toggleClass('locked');
    });
}



// Showing/hiding header on scroll
//-----------------------------------------------------------------
mp.stickyHeader = function() {

    var $header = $('.header'),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 0,
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    var st = $(window).scrollTop();

    if (st > 0 ) {
        didScroll = true;
    }

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        } else {
            didScroll = true;
        }

        if (st > lastScrollTop && st > headerHeight){
            // Scroll down
            $header.removeClass('nav_down').addClass('nav_up');
        }
        else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass('nav_up').addClass('nav_down');
        }
        
        if ($(window).scrollTop() <= 100) {
            $header.removeClass('nav_down nav_up');
        }

        lastScrollTop = st;
    }

};


$(document).ready(function(){
    mp.MenuToggle();
    mp.stickyHeader();
    //mp.submenuToggle();
});